import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

/**
 * @param {{
 *   tabs: string[],
 *   activeTab: number | string,
 *   onChange: (value: number | string) => void,
 *   counts?: Record<string, number>,
 *   valueKey?: 'index' | 'label'
 * }} props
 *
 * valueKey='index' (default) — onChange receives the numeric index.
 * valueKey='label'           — onChange receives the tab label string (useful when
 *                              tabs map to string filters like badgesSubjectsApplication).
 */
const CustomTabs = ({ tabs, activeTab, onChange, counts, valueKey = 'index' }) => {
  const classes = useStyles()

  return (
    <Box className={classes.tabs}>
      {tabs.map((label, i) => {
        const value = valueKey === 'label' ? label : i
        const isActive = activeTab === value
        const count = counts?.[label]

        return (
          <Box
            key={label}
            className={`${classes.tab} ${isActive ? classes.tabActive : ''}`}
            onClick={() => onChange(value)}>
            <Typography style={{ fontSize: 'inherit', fontWeight: 'inherit', color: 'inherit' }}>
              {label}
            </Typography>
            {count !== undefined && <span className={classes.countBadge}>{count}</span>}
          </Box>
        )
      })}
    </Box>
  )
}

export default CustomTabs

const useStyles = makeStyles(() => ({
  tabs: {
    display: 'flex',
    gap: '4px',
    padding: '10px 16px 0',
    borderBottom: '1px solid #e8e8e8',
    backgroundColor: '#fafafa'
  },
  tab: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#999',
    cursor: 'pointer',
    padding: '6px 16px',
    borderRadius: '6px 6px 0 0',
    userSelect: 'none',
    transition: 'color 0.15s',
    marginBottom: '-1px',
    border: '1px solid transparent',
    backgroundColor: 'transparent',
    '&:hover': { color: '#555' }
  },
  tabActive: {
    color: '#00BCD4',
    fontWeight: 700,
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    borderBottom: '1px solid #fff'
  },
  countBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
    height: '20px',
    padding: '0 5px',
    borderRadius: '10px',
    backgroundColor: '#00BCD4',
    color: '#fff',
    fontSize: '11px',
    fontWeight: 700,
    lineHeight: 1,
    flexShrink: 0
  }
}))
